import React, { useState } from "react";
import { Modal, Table, Button, Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import LoadingSpinner from "../../Components/spinner";
import Pagination from "../../Components/pagination";

const SEOTable = ({
  data,
  onEdit,
  onDelete,
  onToggleStatus,
  loading,
  pagination,
  onPageChange,
}) => {
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  if (loading && data.length === 0) {
    return (
      <div className="d-flex justify-content-center p-5">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  const handleStatusChange = async (data) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of page metadata?`,
      okay: "Change",
      method: changeStatus,
      data: { id: data.id, status: data.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
      await onToggleStatus(data);
      setModalOptions({});
      setShowOptionsModal(false);
    };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  return (
    <div className="position-relative">
      <div className={`table-responsive ${loading ? "opacity-50" : ""}`}>
        <Table
          responsive
          hover
          variant="dark"
          className="table table-dark table-striped w-100"
        >
          <thead>
            <tr className="border-bottom border-secondary">
              <th>Page Name</th>
              <th>Page Code</th>
              <th>Meta Title</th>
              <th>Status</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr
                  key={item.id}
                  className="align-middle border-bottom border-secondary"
                >
                  <td>{item.page_name}</td>
                  <td>
                    <code className="text-info">{item.page_code}</code>
                  </td>
                  <td title={item.meta_title}>
                    {item.meta_title?.length > 40
                      ? item.meta_title.substring(0, 40) + "..."
                      : item.meta_title || "N/A"}
                  </td>
                  <td>
                    <button
                      className={`btn btn-link p-0 text-decoration-none ${
                        item.status === 1 ? "text-success" : "text-warning"
                      }`}
                      onClick={() => {
                        handleStatusChange(item);
                      }}
                    >
                      {item.status === 1 ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td>
                    <div className="d-flex gap-2 justify-content-end">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => onEdit(item)}
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => onDelete(item.id)}
                      >
                        <FaTrash />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-secondary">
                  No metadata found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Modal
          show={showOptionsModal}
          onHide={handleCloseOptionsModal}
          centered
          className="text-light"
        >
          <Modal.Header closeButton className="bg-dark text-light border-0">
            <Modal.Title>{modalOptions.header}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-dark text-light">
            {modalOptions.body}
          </Modal.Body>
          <Modal.Footer className="bg-dark text-light border-0">
            <Button variant="secondary" onClick={handleCloseOptionsModal}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                modalOptions.method(modalOptions.data);
              }}
            >
              {modalOptions.okay}
            </Button>
          </Modal.Footer>
        </Modal>
        {pagination && pagination.totalPages > 1 && (
          <div className="mt-4 d-flex justify-content-end">
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SEOTable;
